// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Card (Box) and the table inside it.
 */

.gh-box {
  background-color: var(--gh-canvas-default);
  border: 1px solid var(--gh-border-default);
  border-radius: var(--gh-radius);
  /* Clip inner elements (such as table corners) so they don't overflow the rounded corners */
  overflow: hidden;
}

.gh-box-header {
  padding: 14px 24px;
  border-bottom: 1px solid var(--gh-border-default);
  background-color: var(--gh-canvas-inset);
  border-top-left-radius: var(--gh-radius);
  border-top-right-radius: var(--gh-radius);
  font-weight: 600;
}

.gh-box-body {
  padding: 32px;
}

.gh-box table {
  margin-bottom: 0;
}

.gh-box table thead th {
  background-color: var(--gh-canvas-subtle);
  color: var(--gh-fg-muted);
  font-weight: 500;
  border-bottom: 1px solid var(--gh-border-default);
}

.gh-box table td {
  vertical-align: middle;
  background-color: var(--gh-canvas-default);
}

/* Remove the bottom border of the last row (it looks doubled with the box border) */
.gh-box table tbody tr:last-child td {
  border-bottom: 0;
}
`, "",{"version":3,"sources":["webpack://./src/styles/box.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,0CAA0C;EAC1C,0CAA0C;EAC1C,+BAA+B;EAC/B,2FAA2F;EAC3F,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iDAAiD;EACjD,wCAAwC;EACxC,wCAAwC;EACxC,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,yBAAyB;EACzB,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA;EACE,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA,oFAAoF;AACpF;EACE,gBAAgB;AAClB","sourcesContent":["/*\n * Card (Box) and the table inside it.\n */\n\n.gh-box {\n  background-color: var(--gh-canvas-default);\n  border: 1px solid var(--gh-border-default);\n  border-radius: var(--gh-radius);\n  /* Clip inner elements (such as table corners) so they don't overflow the rounded corners */\n  overflow: hidden;\n}\n\n.gh-box-header {\n  padding: 14px 24px;\n  border-bottom: 1px solid var(--gh-border-default);\n  background-color: var(--gh-canvas-inset);\n  border-top-left-radius: var(--gh-radius);\n  border-top-right-radius: var(--gh-radius);\n  font-weight: 600;\n}\n\n.gh-box-body {\n  padding: 32px;\n}\n\n.gh-box table {\n  margin-bottom: 0;\n}\n\n.gh-box table thead th {\n  background-color: var(--gh-canvas-subtle);\n  color: var(--gh-fg-muted);\n  font-weight: 500;\n  border-bottom: 1px solid var(--gh-border-default);\n}\n\n.gh-box table td {\n  vertical-align: middle;\n  background-color: var(--gh-canvas-default);\n}\n\n/* Remove the bottom border of the last row (it looks doubled with the box border) */\n.gh-box table tbody tr:last-child td {\n  border-bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
